import debounce from '@tinkoff/utils/function/debounce'
import { useEffect, useState } from 'react'

export const useScreenWidth = () => {
  const [width, setWidth] = useState(__SSR__ ? 1024 : window.innerWidth)
  useEffect(() => {
    const handler = debounce(16, () => {
      setWidth(window.innerWidth)
    })
    window.addEventListener('resize', handler)
    return () => window.removeEventListener('resize', handler)
  })
  return width
}
